import { Injectable } from '@angular/core';
import { AOR } from '../../model/locations/aor';
import { AORSubSystem } from '../../model/locations/aor-subsystem';

@Injectable({
  providedIn: 'root',
})
export class AorBuilderService {
  constructor() {}

  buildAor(item: any): AOR {
    const buildContactSummary = (contact: any) =>
      contact
        ? {
            id: contact.id,
            firstName: contact.firstName ?? '',
            lastName: contact.lastName ?? '',
            fullName:
              `${contact.firstName ?? ''} ${contact.lastName ?? ''}`.trim(),
          }
        : null;

    const retVal = {
      id: item.id,
      name: item.name,
      version: item.version,
      enabled: item.enabled,
      abbreviation: item.abbreviation,
      dopGroupId: item.dopGroupId,
      dopGroup: item.DOPGroup,
      businessUnitId: item.businessUnitId,
      gcSupervisor: buildContactSummary(item.gcSupervisor),
      gcManager: buildContactSummary(item.gcManager),
      dopEntries:
        item.DOPEntries && item.DOPEntries.length > 0
          ? item.DOPEntries.map((item: any) => ({
              id: item.id,
              aorId: item.aorId,
              aorSubSystemId: item.aorSubSystemId,
              labelId: item.labelId,
              entry: item.entry,
              shiftDate: item.shiftDate,
              createdBy: item.createdBy,
              createdAt: item.createdAt,
              updater: item.updater,
              updatedAt: item.updatedAt,
              deletedAt: item.deletedAt,
              version: item.version,
            }))
          : [],
      aorSubSystems:
        item.AORSubSystems && item.AORSubSystems.length > 0
          ? item.AORSubSystems.map((item: any) => this.buildAORSubsystem(item))
          : [],
    };
    return retVal;
  }

  buildAORSubsystem(item: any): AORSubSystem {
    return {
      id: item.id,
      aorId: item.aorId,
      name: item.name,
      enabled: item.enabled,
      deletedAt: item.deletedAt,
    };
  }
}
